import styled from 'styled-components'

import RecipeCard from '../../components/RecipeCard'
import Grid from '../../components/Grid'
import { THEME, media, BREAKPOINTS, typeScale, COLORS } from '../../styles'

const Styled = styled.main`
  background: ${THEME.COLORS.background.primary};
  padding: 2.4rem;
  text-align: center;
  display: flex;
  min-height: inherit;
  place-content: stretch center;
  flex-flow: column nowrap;
  ${media.medium`
    padding: 3.6rem;
  `}
`
Styled.content = styled.div`
  width: 100%;
  max-width: ${BREAKPOINTS.large};
  margin: 0 auto;
`
Styled.recipes = styled(Grid)`
  position: relative;
  margin: 0 auto;
  width: 100%;
`
Styled.recipesItem = styled.div`
  position: relative;
  width: auto;
`
Styled.recipeCard = styled(RecipeCard)`
  height: 100%;
`
Styled.title = styled.h1`
  ${typeScale('headline1')};
  text-align: center;
`
Styled.separator = styled.hr`
  width: 24rem;
  display: block;
  margin: 3.2rem auto;
  height: 1.6rem;
  background-color: ${COLORS.yolk};
  border: 0;
  padding: 0;
`
Styled.subtitle = styled.p`
  ${typeScale('button')};
  text-align: center;
  padding-bottom: 1.6rem;
`

export default Styled
